export default __webpack_public_path__ + "static/media/22.b533d7ff.svg";